import { render, staticRenderFns } from "./stationeryRecordEdit.vue?vue&type=template&id=1306af36&scoped=true"
import script from "./stationeryRecordEdit.vue?vue&type=script&lang=js"
export * from "./stationeryRecordEdit.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecordEdit.vue?vue&type=style&index=0&id=1306af36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1306af36",
  null
  
)

export default component.exports